import { cn } from "@/infrastructure/adapters/classnames";
import { IDeductionChip, PRIORITY_ICONS, PriorityKey } from "./IDeductionChips";
import { getPriorityChipClassName } from "./DeductionChipUtils";
import { DeductionChip } from "./DeductionChip";
import { Button, Tooltip } from "@ir/ui";

interface PriorityChipProps extends IDeductionChip {
  priorityKey: string;
  priorityName?: string;
}

export const PriorityChip = ({
  priorityKey,
  priorityName,
  withIcon = false,
  iconSize,
  withBorder = true,
  withBackground = false,
  size = "small",
  style,
  className,
  shape = "square",
}: PriorityChipProps) => {
  if (!priorityKey) {
    return null;
  }

  const icon = PRIORITY_ICONS[priorityKey as PriorityKey];
  const classNames = cn(getPriorityChipClassName(priorityKey as PriorityKey, withBorder, withBackground), "priority-chip", className);

  return (
    <Tooltip content={priorityName}>
      <Button noStyle style={{ cursor: "default"}}>
        <DeductionChip
          icon={withIcon && icon ? icon : undefined}
          size={size}
          iconSize={iconSize}
          shape={shape}
          style={style}
          className={classNames}
        />
      </Button>
    </Tooltip>
  );
};
